import React from 'react';



const Dashboard: React.FC = () => {

  const stats = [
    {
      title: 'Total Users',
      value: '1,234',
      icon: 'pi-users',
      gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      change: '+12%',
      changeText: 'from last month',
      isPositive: true
    },
    {
      title: 'Active Sessions',
      value: '482',
      icon: 'pi-chart-line',
      gradient: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
      change: '+8%',
      changeText: 'from yesterday',
      isPositive: true
    },
    {
      title: 'Messages',
      value: '89',
      icon: 'pi-envelope',
      gradient: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
      change: '-3%',
      changeText: 'from last week',
      isPositive: false
    },
    {
      title: 'Calendar Events',
      value: '24',
      icon: 'pi-calendar',
      gradient: 'linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)',
      change: '+5',
      changeText: 'upcoming this week',
      isPositive: true
    }
  ];

  return (
    <div>
      <h2 style={{ fontSize: '28px', fontWeight: '600', marginBottom: '8px' }}>Dashboard</h2>
      <p style={{ color: '#6b7280', marginBottom: '32px' }}>
        Welcome back, 
      </p>
      
      <div style={{ 
        display: 'grid', 
        gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', 
        gap: '20px' 
      }}>
        {stats.map((stat, index) => (
          <div key={index} style={{
            background: 'white',
            padding: '24px',
            borderRadius: '12px',
            boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
            border: '1px solid #f1f5f9'
          }}>
            <div style={{ 
              display: 'flex', 
              justifyContent: 'space-between', 
              alignItems: 'flex-start', 
              marginBottom: '12px' 
            }}>
              <div>
                <p style={{ 
                  color: '#6b7280', 
                  fontSize: '14px', 
                  margin: '0 0 8px' 
                }}>
                  {stat.title}
                </p>
                <h3 style={{ 
                  fontSize: '32px', 
                  fontWeight: '700', 
                  margin: 0, 
                  color: '#1f2937' 
                }}>
                  {stat.value}
                </h3>
              </div>
              <div style={{
                width: '48px',
                height: '48px',
                background: stat.gradient,
                borderRadius: '12px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                <i className={`pi ${stat.icon}`} style={{ 
                  fontSize: '20px', 
                  color: 'white' 
                }}></i>
              </div>
            </div>
            <p style={{ 
              fontSize: '13px', 
              color: stat.isPositive ? '#10b981' : '#ef4444', 
              margin: 0 
            }}>
              <i className={`pi ${stat.isPositive ? 'pi-arrow-up' : 'pi-arrow-down'}`} style={{ 
                fontSize: '12px' 
              }}></i> {stat.change} {stat.changeText}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Dashboard;